<template>
    <div class="square-text-box">
        <ContentComponentItems
            :background="data.backgroundColor"
            :data="data.content"
            :has-eager-image="hasEagerImage"
            :page-type="pageType"
        />
    </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import type { SquareTextBoxFragment } from '@/graphql/api'
import { type ButtonColors } from '@/components/ui/buttons'
import { cmsColorToButtonColor } from '@/components/cms'

import ContentComponentItems from '@/components/cms/component/ContentComponentItems.vue'
import type { PageType } from '@/components/cms/component/content/ContentButton.vue'

const props = defineProps<{
    data: SquareTextBoxFragment
    hasEagerImage?: boolean
    pageType: PageType
}>()

const backgroundColor = computed(
    (): ButtonColors => cmsColorToButtonColor(props.data.backgroundColor)
)
</script>

<style lang="scss" scoped>
.square-text-box {
    width: 100%;
    aspect-ratio: 1/1;
    background: v-bind(backgroundColor);
    padding: 40px;
    display: flex;
    flex-wrap: wrap;
    align-content: center;
}
</style>
